<template>
  <nav class="main-menu">
    <a
      class="navbar-brand"
      href="#"
      @click.prevent.stop="$router.push('/entries')"
    >
      <img
        src="../assets/logo.svg"
        alt=""
      >
    </a>

    <ul class="list-inline mb-0 mr-auto ml-4">
      <router-link
        class="list-inline-item"
        tag="li"
        to="/entries"
      >
        <a
          class="nav-link main-menu__item text-muted"
          href="#"
        >
          <font-awesome-icon icon="long-arrow-alt-left" />
          Back to entries
        </a>
      </router-link>
    </ul>
    <ul class="list-inline mb-0 mr-3">
      <!--     <li class="list-inline-item">
      <b-dropdown id="actions" text="Actions" class="main-menu__actions" variant="outline-secondary">
        <b-dropdown-item>Save PDF</b-dropdown-item>
        <b-dropdown-item @click= "preview()">Preview</b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item @click = "saveAndSend()" >Save &amp; Send</b-dropdown-item>
      </b-dropdown>
    </li> -->
      <li class="list-inline-item">
        <a
          href="#"
          class="btn btn-outline-secondary"
          @click.prevent.stop="$router.push({ name: 'PageEditorPreview'})"
        >Preview</a>
      </li>
      <li class="list-inline-item">
        <a
          href="#"
          :class="{'disabled': $store.state.entries.status != 'idle'}"
          class="btn btn-outline-secondary"
          @click.stop.prevent="$store.dispatch('entries/saveItem')"
        >
          <span style="width: 68px; display: inline-block;">{{ ($store.state.entries.status == 'idle')? 'Save':$store.state.entries.status }}</span>
        </a>
      </li>
      <li class="list-inline-item">
        <a
          href="#"
          class="btn btn-warning px-4"
          @click.prevent.stop="send"
        >Send email <font-awesome-icon icon="paper-plane" /></a>
      </li>
    </ul>
  </nav>
</template>

<style lang="scss">
  // @import "../styles/main.scss";
  // .main-menu{
  //   @extend .navbar;
  //   @extend .navbar-dark;
  //   @extend .fixed-top;
  //   background-color: #DBE0DC;

  //   &__save{
  //     padding: 0.625rem 2.5rem;
  //     @extend .btn;
  //     @extend .btn-primary;
  //   }
  //   &__actions .btn{
  //     padding: 0.625rem 2.5rem;
  //   }

  //   .btn{
  //     text-transform: uppercase;
  //     font-size: 0.7rem;
  //   }
  // }
</style>

<script>
import { EventBus } from '@/event-bus.js';

export default {
  name: 'AppEditMenu',
  methods: {
    saveAndSend() {
      EventBus.$emit('saveandsend', { type: this.type });
    },
    preview() {
      EventBus.$emit('preview', { type: this.type });
    },
    send() {
      this.$store.dispatch('entries/sendEmail');
    },
  },
};
</script>
